// Every tuned numeric constant the sim's game feel depends on, gathered in
// one place so a tuning change is a diff to this file alone. Numbers only —
// no functions, no World/Aircraft-shaped logic, no side effects. If you're
// computing something, it belongs in spawn.ts, route.ts, query.ts or
// world.ts instead. Do not change a value here without lab evidence.

/** Logical viewport: min(W,H) is normalised to this many px. */
export const LOGICAL_MIN = 390;
export const MAX_VIEW_SCALE = 2.0;

/** how far outside the viewport an arrival appears — and, on the radar, how
 *  far outside the mapped field its gate is drawn */
export const EDGE_MARGIN = 30;

/** nothing live may be within this of the gate when an arrival comes through */
export const GATE_CLEAR = 96;
/** ...and its track must keep at least this much room, which is the warning
 *  band with a little to spare, over the next `GATE_LOOK` seconds */
export const GATE_SEP = 64;
/** how far ahead an entry is projected. Longer than `STRUCTURAL_SPAWN_S` so a
 *  conflict is refused a little before it becomes unsolvable, not after. */
export const GATE_LOOK = 3.5;
/** fraction of its edge a held arrival walks per second, looking for room */
export const GATE_SLIDE = 0.11;

export const SNAP_RUNWAY = 42;   // px from the strip that counts as "reached the runway"
export const SNAP_PAD_EXTRA = 22; // pad radius + this
export const SNAP_TAIL = 12;      // how many trailing points are checked for a snap

/** how far off the runway heading an arrival may be and still be "lined up"
 *  (~23°) when its path runs out — otherwise it goes around */
export const LINEUP_TOL = 0.40;

/** how far past the bars the roll-in guide sits, as a fraction of the strip.
 *  Deliberately short: it exists only so an aircraft crosses the bars along
 *  the runway instead of aiming at a point on it. Where a landing actually
 *  happens is the player's to choose — by drawing further down the strip —
 *  and the game must never fly a stretch of runway nobody drew. */
export const ROLLIN_FRAC = 0.2;
